// extracted by mini-css-extract-plugin
module.exports = {"label":"_6bf2896","isSelected":"_6356e8e3"};